enum ActivityRecurringUnit {
  MONTH = "month",
  WEEK = "week",
  DAY = "day",
}

export default ActivityRecurringUnit;
